import { useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { CalendarClock } from "lucide-react";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WeeklySummaryButton = () => {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/push/weekly-summary/send-to-me`);
      data.sent ? toast.success(t("phoneAlerts.weeklySent")) : toast.error(t("phoneAlerts.weeklyNoDevice"));
    } catch { toast.error(t("phoneAlerts.weeklyFailed")); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 py-2 border-t border-slate-100" data-testid="weekly-summary-section">
      <p className="text-xs text-slate-500 flex items-center gap-2"><CalendarClock className="w-3.5 h-3.5" /> {t("phoneAlerts.weeklyHint")}</p>
      <Button data-testid="weekly-summary-send-now" variant="outline" size="sm" disabled={busy} className="rounded-sm" onClick={send}>
        {t("phoneAlerts.weeklySendNow")}
      </Button>
    </div>
  );
};
